// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import { store } from './store/store'
Vue.use(VueLocalStorage)

import App from './App'
import i18n from './lang/lang'
import router from './router'

import VueCarousel from 'vue-carousel'
import FBSignInButton from 'vue-facebook-signin-button'
import VueTruncate from 'vue-truncate-filter'

import VeeValidate from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import Tooltip from 'vue-directive-tooltip'

import apiMixin from '@/mixins/apiMixin'
import errorMixin from '@/mixins/errorMixin'
import mainMixin from '@/mixins/mainMixin'

import '@/assets/css/vue-directive-tooltip-css.css'

import './filters'

import FlagIcon from 'vue-flag-icon'

import PremiumLock from '@/components/elements/PremiumLock'
import PremiumPlanPopup from '@/components/elements/PremiumPlanPopup'

import VueParticles from 'vue-particles'

import ModalHelp from '@/components/elements/ModalHelp2'
import MainLayout from '@/components/layouts/Main'
import PartnerLayout from '@/components/layouts/Partner'
import { SimpleSVG } from 'vue-simple-svg'
import VueSweetalert2 from 'vue-sweetalert2'
import Vuetify from 'vuetify'

import config from '@/config'

import th from 'vee-validate/dist/locale/th'
// import la from './lang/validate/la'

import { Validator } from 'vee-validate'
import 'vuetify/dist/vuetify.min.css'

import VueGtag from 'vue-gtag'

import VueCountdown from '@chenfengyuan/vue-countdown'
import LoadScript from 'vue-plugin-load-script'

import 'leaflet/dist/leaflet.css'

Vue.prototype.$aston = window.aston
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(LoadScript)

Vue.use(
  VueGtag,
  {
    config: {
      id: 'G-4J7XF1X7WG'
    }
  },
  router
)

const SweetalertoOptions = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, SweetalertoOptions)

Vue.use(Vuetify, {
  theme: {
    primary: config.theme.brand_color
  }
})
Vue.use(VueParticles)

Vue.use(Tooltip)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Validator.localize({ th: th })
// Validator.localize({ la: la })
// ห้ามใส่ inject=false ในการใช้งาน VeeValidate ไม่งั้นจะทำให้การทำงานของ VeeValidate ไม่สมบูรณ์
// vuetify ถ้าอยากให้ inject ให้ใช้ inject: ['$validator'] ใน component และไม่ใช้ v-card ในการครอบ
Vue.use(VeeValidate, { locale: 'th', events: 'blur|change' })
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueTruncate)

Vue.use(FlagIcon)

Vue.component('MainLayout', MainLayout)
Vue.component('PartnerLayout', PartnerLayout)
Vue.component('VModalHelp', ModalHelp)
Vue.component('VPremiumLock', PremiumLock)
Vue.component('VPremiumPlanPopup', PremiumPlanPopup)

Vue.component('VueSimpleSvg', SimpleSVG)

Vue.config.productionTip = false

Validator.extend(
  'isLessThanOrEqual',
  (value, [otherValue]) => {
    return parseFloat(value) <= parseFloat(otherValue)
  },
  {
    hasTarget: true
  }
)

Validator.extend('isUrl', (value) => {
  var pattern = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  ) // fragment locator
  return pattern.test(value)
})
Validator.extend('excludednew', {
  getMessage: (field) => field + Vue.prototype.$t('are duplicate please change to another one'),
  validate: (value, [...otherValue]) => {
    var obj = value.replace(/,/g, '').replace(/[|]/g, '//#or//')
    return !otherValue.includes(obj)
  }
})
Validator.extend('isPhone', (value) => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value)
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)
Vue.mixin(apiMixin)

Vue.component('VStyle', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js